module.exports = __webpack_public_path__ + "static/media/img-audio-default.f98fe37c.png";